import { Modal as SLModal, Text } from '@prenuvo/shared-library';

type ModalType = {
  title: string;
  message: string;
  onClose: () => void;
  modalCTA?: ModalCTAType;
};

export type ModalCTAType = {
  text?: string;
  handleClick?: () => void;
};

const Modal = ({ title, message, onClose, modalCTA }: ModalType) => {
  return (
    <SLModal
      title={title}
      showButtons
      onPress={() => {
        modalCTA && modalCTA.handleClick && modalCTA.handleClick();
        onClose();
      }}
      onClose={onClose}
      submitText={modalCTA && modalCTA.text}
    >
      <Text noMargin>{message}</Text>
    </SLModal>
  );
};

export default Modal;
